import React, { Component } from 'react';
import JForm from './components/JForm';
import 'semantic-ui-css/semantic.min.css';
import './App.css';
import JMenu from './components/JMenu';
import sspalogo from './sspalogo.png';

class App extends Component {
  constructor(props) {
    super(props)

    this.state = { primary : {"FLOW_MODEL_TYPE" : {"MODFLOW": {}}, 
                              "SIMULATIONS" : [] }
                  };
    
    this.options = {
      modeltypes : ['MODFLOW'],  //,'MEUK'],
      simtypes :   ['PATHLINE','ENDPOINT'],
      meukopts :   ['KRIGE_ONLY'],
      boundaries : ["WEL","DRN","RIV","EVT","GHB","RCH","FHB","STR","CHD","SFR","MNW2","MNW1","CLN"],
      precision :  ['','SINGLE','DOUBLE'],
      threads :    ['',1,2,3,4,5,6,7,8,9,10,11,12],
      directions : ['','FORWARD','BACKWARD'],
      advoptions : ['DISPERSION','RETARDATION','TRACK_TO_TERMINATION','DOPRI'],
      iface      : [0,2,5,6,7]
     }

    this.jsonUpdate = this.jsonUpdate.bind(this);
  }

  jsonUpdate(newPrimary) {
    this.setState({primary : newPrimary});
  }

  // Typecasting Reals does a bad job, so we're fixing it on the display/output end
  realizeSimulationStrings(jsonIn, keys) {
    // Work on a clone
    let json = JSON.parse(JSON.stringify(jsonIn));
    if (json['SIMULATIONS'] !== undefined) {
      for (let isim=0; isim < json['SIMULATIONS'].length; isim++) {
        let simType = Object.keys(json['SIMULATIONS'][isim])[0];
        let thisSim = json['SIMULATIONS'][isim][simType];
        for (let i=0; i < keys.length; i++) {
          if (thisSim[keys[i]] !== undefined){
            thisSim[keys[i]] = parseFloat(thisSim[keys[i]]);
          }
        }
        Object.keys(json['SIMULATIONS'][isim])[0] = thisSim;
      }
    }
    return json;
  }

  // Just some real simple code here
  syntaxHighlight(json) {
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = 'number';
        if (/^"/.test(match)) {
            if (/:$/.test(match)) {
                cls = 'key';
            } else {
                cls = 'string';
            }
        } else if (/true|false/.test(match)) {
            cls = 'boolean';
        } else if (/null/.test(match)) {
            cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
    });
}

  render() {
    const {primary} = this.state;
    const realBad = ['ADAPTIVE_STEP_ERROR', 'INITIAL_STEPSIZE', 'MAX_STEPSIZE', 'STAGNATION_DT',
                     'EULER_DT', 'SIMULATION_END_TIME', 'CAPTURE_RADIUS'];
    const realPrimary = this.realizeSimulationStrings(primary, realBad)
    const json = this.syntaxHighlight(JSON.stringify(realPrimary, null, 2));

    return (
      <div className="App">
        <header className="App-header">
          <a href="http://www.sspa.com/" target="_blank" rel="noopener noreferrer">
            <img src={sspalogo} alt="SSPA Logo" className="sspalogo" />
            </a>
          <h1>mod-PATH3DU Primary File Generator</h1>
        </header>
        <div className="App-Content">
          <div className="App-Form">
            <JForm primary={primary} options={this.options} jsonUpdate={this.jsonUpdate}/>
          </div>
          <div className="App-View">
            <JMenu primary={realPrimary} jsonImport={this.jsonUpdate} />
            <pre dangerouslySetInnerHTML={{__html: json}}></pre>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
